import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCommonModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { fuseAnimations } from 'src/@fuse/animations';
import { FuseConfigService } from 'src/@fuse/services/config.service';
import { FuseSharedModule } from 'src/@fuse/shared.module';
import { UnlockConstants } from 'src/app/shared/constants/unlock.constants';

import { LoadingComponent } from '../../generals/loading/loading.component';
import { NumberBoardComponent } from '../../generals/number-board/number-board.component';
import { PinCodeConfig } from '../../generals/pin-code/pin-code-config';
import { PinCodeComponent } from '../../generals/pin-code/pin-code.component';
import { WellcomeComponent } from '../../generals/wellcome/wellcome.component';
import { AppManageService } from '../../services/app-manage.service';
import { LockResponse } from '../../services/microservices/response/lock.response';
import { MicroResponse } from '../../services/microservices/response/micro.response';
import { SimpleResponse } from '../../services/microservices/response/simple.response';
import { UserService } from '../../services/user.service';
import { SessionService } from '../../services/user/session/session.service';
import { DataToForgotPassword } from '../forgot-password/object-type/DataToForgotPassword';
import { UnlockStep } from './unlock-step.enum';

@Component({
  selector: 'unlock',
  templateUrl: './unlock.component.html',
  styleUrls: ['./unlock.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCommonModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSnackBarModule,
    MatMomentDateModule,
    MatAutocompleteModule,
    MatSelectModule,
    FuseSharedModule,
    FlexLayoutModule,
    NgxMatSelectSearchModule,
    RouterLink,
    WellcomeComponent,
    LoadingComponent,
    PinCodeComponent,
    NumberBoardComponent,
  ],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class UnlockComponent implements OnInit {
  pinCode = '';
  cardId = '';
  email = '';
  boardPinCode = '';
  message = '';
  unlockForm: FormGroup;
  cambiarForm!: FormGroup;
  dataUser!: DataToForgotPassword;
  step: number = UnlockStep.lock;
  registep: typeof UnlockStep = UnlockStep;
  @ViewChild(PinCodeComponent) pinCodeComp!: PinCodeComponent;
  pinCodeConfig: PinCodeConfig = { isPinCodeBoard: true };
  isUserUnlock = false;
  isLoading = false;

  // eslint-disable-next-line
  constructor(
    private _fuseConfigService: FuseConfigService,
    private _formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    private _userService: UserService,
    private _sessionService: SessionService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _appManageService: AppManageService,
  ) {
    // Configure the layout
    this._fuseConfigService.config = {
      layout: {
        navbar: { hidden: true },
        toolbar: { hidden: true },
        footer: { hidden: true },
        sidepanel: { hidden: true },
      },
    };
    this.unlockForm = this._formBuilder.group({
      pinCode: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  ngOnInit(): void {
    const url = window.location.href;
    this._appManageService.detectarDispositivo(url);

    this._route.queryParamMap.subscribe((query: any) => {
      if (Object.keys(query.params).length) {
        this._userService.lockUser(query.params.id).subscribe({
          next: (response: MicroResponse<LockResponse>) => {
            if (response.data.processResult) {
              switch (response.data.processResult.id) {
                case UnlockConstants.USER_LOCKED:
                  this.dataUser = {
                    username: response.data.email,
                  } as DataToForgotPassword;
                  this.step = UnlockStep.securityPin;
                  break;
                case UnlockConstants.USER_NOT_FOUND:
                  this.message = 'Usuario no encontrado';
                  break;
                case UnlockConstants.BLOCKING_PERIOD_EXPIRED:
                  this.message = 'Expiró el período permitido';
                  break;
                case UnlockConstants.CANNOT_BLOCK_USER:
                  this.message =
                    'No es posbile desbloquear la cuenta, por favor acceda nuevamente al sistema';
                  break;
              }
            }
          },
          error: () => {
            this.message = 'Ocurrió algo';
          },
        });
      } else {
        this.step = UnlockStep.securityPin;
        this._sessionService.dataLoginForgot$.subscribe(data => {
          this.dataUser = data as DataToForgotPassword;
        });
      }
    });
  }

  sendPinCode(): void {
    this.isLoading = true;
    const pinCode = this.unlockForm.get('pinCode')?.value;
    if (pinCode && this.dataUser.username) {
      this._userService
        .processPinAndMessage(this.dataUser.username, pinCode.toString())
        .subscribe({
          next: (response: MicroResponse<SimpleResponse>) => {
            this.isLoading = false;
            switch (response.data.id) {
              case 1:
                this.step = this.registep.emailSent;
                this.email = this.dataUser.username;
                this.checkStatusUser();
                break;
              case 2:
                this.openSnack('Ingrese nuevamente el pin');
                this.pinCodeComp.resetComponent();
                this.resetPinValue();
                break;
              case 3:
                this.openSnack('La información es inconsistente');
                this.pinCodeComp.resetComponent();
                this.resetPinValue();
                break;
            }
          },
          error: () => {
            this.openSnack('Ocurrio algo');
          },
        });
    }
  }

  processPin(pinCode: string) {
    this.unlockForm.patchValue({ pinCode: pinCode });
  }

  exit(): void {
    this._router.navigate(['login']);
  }

  showExitButton(): boolean {
    return (
      this.step === this.registep.securityPin &&
      this.unlockForm.get('pinCode')!.invalid
    );
  }

  private checkStatusUser() {
    const intervalo = setInterval(() => {
      this._userService.getValidationStatus(this.email).subscribe({
        next: (response: any) => {
          if (response.data === true) {
            this.isUserUnlock = response.data;
            clearInterval(intervalo);
          }
        },
      });
    }, 7000);
  }

  private openSnack(message: string): void {
    this._snackBar.open(message, '', {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      panelClass: ['snack-error'],
    });
  }

  receiveValue(value: string) {
    if (value.toString().match('Atras')) {
      this.exit();
      this.boardPinCode = '';
      return;
    }
    if (value.toString().match('Borrar')) {
      this.boardPinCode = this.boardPinCode.slice(0, -1);
      value = '';
    }
    if (this.boardPinCode.length === 6) {
      value = '';
    }
    this.boardPinCode += value;
    this.processPin(this.boardPinCode);
  }

  resetPinValue(): void {
    this.boardPinCode = '';
    this.unlockForm.patchValue({ pinCode: '' });
  }
}
